import LegalLayout from '../components/legal/LegalLayout';

export default function Imprint() {
  return (
    <LegalLayout 
      title="Impressum" 
      lastUpdated="15. Februar 2026"
    >
      <section className="space-y-8">
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Angaben gemäß § 5 TMG</h2>
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-6 mb-4">
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-white">Azrefy</strong><br />
              Freiburg im Breisgau<br />
              Deutschland
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Kontakt</h2>
          <div className="bg-gray-900 border border-gray-800 rounded-lg p-6 mb-4">
            <p className="text-gray-300 leading-relaxed">
              E-Mail: hello@azrefy.com
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">EU-Streitschlichtung</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            <a 
              href="https://ec.europa.eu/consumers/odr/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 underline"
            >
              https://ec.europa.eu/consumers/odr/
            </a>
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Unsere E-Mail-Adresse finden Sie oben im Impressum.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Haftung für Inhalte</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
            allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht 
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen 
            zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
            Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
            der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
            Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Haftung für Links</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der 
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
            Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche 
            Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht 
            zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Urheberrecht</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
            deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
            außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors 
            bzw. Erstellers.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. 
            Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem 
            auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. 
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-white mb-4">Finanzdienstleistungen</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            Azrefy ist keine Bank und bietet keine Finanzdienstleistungen im Sinne des Kreditwesengesetzes (KWG) an. 
            Wir vermitteln keine Finanzprodukte und nehmen keine Einlagen entgegen. Die App dient ausschließlich 
            der Übersicht und Analyse Ihrer bestehenden Bankkonten.
          </p>
          <p className="text-gray-300 leading-relaxed mb-4">
            Die Kontoverknüpfung erfolgt über lizenzierte PSD2-Schnittstellen. Azrefy handelt dabei als 
            Kontoinformationsdienstleister gemäß der Payment Services Directive 2 (PSD2).
          </p>
        </div>

        <div className="bg-blue-900/20 border border-blue-500/30 rounded-xl p-6">
          <p className="text-gray-300 leading-relaxed">
            <strong className="text-white">Quelle:</strong> Erstellt mit Unterstützung von 
            <a 
              href="https://www.e-recht24.de" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 underline ml-1"
            >
              e-recht24.de
            </a>
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
